export default loanTerms => loanTerms.map(termLength => ({ label: `${termLength} months`, value: termLength }));